import { useEffect, useRef, useState } from "react";

/* Scroll-triggered reveal wrapper. Renders children immediately (SEO/prerender safe)
   and fades/slides them in once in view. Respects prefers-reduced-motion via CSS. */
export const Reveal = ({ children, delay = 0, as: Tag = "div", className = "", ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { setShown(true); return; }
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) { setShown(true); obs.disconnect(); }
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag ref={ref} className={`sr ${shown ? "is-visible" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};
